import { AxiosResponse } from 'axios';
import { api } from 'hooks/useApi';

type FeedbackPayload = {
  feedback: string;
  project_id?: number;
  company_id?: string;
  page_url: string;
  user_email: string;
};

const postProductFeedback = (payload: FeedbackPayload): Promise<AxiosResponse> => {
  return api.post('/notifications/product-feedback/', payload);
};

const getNotificationSettings = (userId: string): Promise<AxiosResponse> => {
  return api.get(`/notifications/settings/${userId}/`);
};

const postNotificationSettings = (
  userId: string,
  data: { project_group_enabled: boolean },
): Promise<AxiosResponse> => {
  return api.post(`/notifications/settings/${userId}/`, data);
};

const postMissingCompany = (companyName: string): Promise<AxiosResponse> => {
  return api.post('/notifications/missing-company/', { companyName });
};

const postShareCollection = (
  collectionId: number,
  email: string,
): Promise<AxiosResponse> => {
  return api.post(`/notifications/collections/${collectionId}/share/`, { email });
};

export default {
  postProductFeedback,
  getNotificationSettings,
  postNotificationSettings,
  postMissingCompany,
  postShareCollection,
};
